import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ActionValidIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path
      fillRule="evenodd"
      d="m6.751 12.792 5.17-8.021-.841-.542-4.498 6.98-2.228-2.23-.708.708 3.105 3.105Z M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm-1 0A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z"
    />
  </IconWrapper>
)

export default ActionValidIconSmall
